/**
 * Toggle an id existing in an array
 */
export const toggleMultiSelectItemId =
  (selectedId: string) => (prevSelected: string[]) => {
    const selected = prevSelected.filter((itemId) => itemId !== selectedId);
    if (selected.length === prevSelected.length) {
      selected.push(selectedId);
    }
    return selected;
  };
